module.exports = __webpack_public_path__ + "common/icon-drawer-menu-ef8118bf342da42fe9bf1f8661110b80.svg";